/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_H1Inputs */

const en_formatter_h1 = /** @type {(inputs: Formatter_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Formatter`)
};

const ko_formatter_h1 = /** @type {(inputs: Formatter_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 포맷터`)
};

const ja_formatter_h1 = /** @type {(inputs: Formatter_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONフォーマッター`)
};

/**
* | output |
* | --- |
* | "JSON Formatter" |
*
* @param {Formatter_H1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_h1 = /** @type {((inputs?: Formatter_H1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_H1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_h1(inputs)
	if (locale === "ko") return ko_formatter_h1(inputs)
	return ja_formatter_h1(inputs)
});